import { createReducer } from 'typesafe-actions';
import { createRoutineReducers, getInitialState } from '../common/utils/routine-reducer';
import { removeRoleRoutine, saveRoleRoutine, updateRoleRoutine } from './actions';

export const initialState = getInitialState({});

export default createReducer(initialState, {
  ...createRoutineReducers(saveRoleRoutine),
  ...createRoutineReducers(updateRoleRoutine),
  ...createRoutineReducers(removeRoleRoutine)
});
